import { useEffect, useState } from 'react';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../helpers/Axios";
import { Box, Typography } from '@mui/material';

type Props = {
  value: string | null;
  onChange: (value: string | null) => void;
};

const StageImagePicker = ({ value, onChange }: Props) => {
  const [images, setImages] = useState<string[]>([]);

  useEffect(() => {
    const loadImages = async () => {
      const res = await axiosInstance   .get('/image');

      const folder = res.data.find(
        (f: any) => f.name === 'stages'
      );

      if (folder?.files) {
        setImages(folder.files.sort());
      }
    };

    loadImages();
  }, []);

  const isSelected = (file: string) =>
    value === `/images/stages/${file}`;

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Image du stage
      </Typography>

      {/* Bouton "aucune image" */}
      <Box
        onClick={() => onChange(null)}
        sx={{
          mb: 2,
          cursor: 'pointer',
          color: !value ? 'primary.main' : 'text.secondary',
          fontWeight: !value ? 'bold' : 'normal',
        }}
      >
        ❌ Aucune image
      </Box>

      {/* Grille de vignettes */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, 120px)',
          gap: 2,
        }}
      >
        {images.map(file => {
          const src = `${import.meta.env.VITE_BACKEND_URL}/images/stages/${file}`;
          const selected = isSelected(file);

          return (
            <Box
              key={file}
              onClick={() => onChange(`/images/stages/${file}`)}
              sx={{
                borderRadius: 2,
                overflow: 'hidden',
                cursor: 'pointer',
                border: selected
                  ? '3px solid #1976d2'
                  : '2px solid transparent',
                boxShadow: selected
                  ? '0 0 0 3px rgba(25,118,210,0.3)'
                  : '0 4px 10px rgba(0,0,0,0.2)',
                transition: 'all 0.2s',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <img
                src={src}
                alt={file}
                style={{
                  width: '100%',
                  height: 120,
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default StageImagePicker;